// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner-module--spinner--1jnH1","load2":"Spinner-module--load2--3uFb0"};